import { render, staticRenderFns } from "./BaseFor.vue?vue&type=template&id=439df5e3&scoped=true"
import script from "./BaseFor.vue?vue&type=script&lang=js"
export * from "./BaseFor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "439df5e3",
  null
  
)

export default component.exports